import VoiceCallActionExecution from "./VoiceCallAction";
import { AssistantNodeAction } from "V2.0/HomePages/PipelinesV2/PipelineBuilderV2/Models/NodeType";

export default AssistantExecution;

const AssistantActionExecutionRegistry = {
  [AssistantNodeAction.VOICE_CALL]: VoiceCallActionExecution,
  [AssistantNodeAction.WHATSAPP_MESSAGE]: VoiceCallActionExecution
};

function AssistantExecution(props) {
  const { node } = props;

  const AssistantActionExecution =
    AssistantActionExecutionRegistry[node.data.action as AssistantNodeAction];

  return <AssistantActionExecution {...props} />;
}
